import { HubConnectionBuilder, LogLevel, type HubConnection } from '@microsoft/signalr';
import { API_BASE_URL, getAccessToken } from './api';

/**
 * The ONE way a hub connection is built — FRONTEND_REFERENCE: "Real-time via `lib/signalr.ts`".
 *
 * - **The token is read on every (re)connect**, never captured — a token re-issued after a
 *   security-stamp rotation is the one the next attempt presents. SignalR sends it as
 *   `?access_token=` on the WebSocket upgrade, which the API accepts on `/hubs` paths only.
 * - **Reconnects by itself.** The caller starts it and stops it on unmount; nothing else.
 *
 * `path` is the hub's path under the API origin, e.g. `/hubs/session`.
 */
export function createHubConnection(path: string): HubConnection {
  return new HubConnectionBuilder()
    .withUrl(`${API_BASE_URL}${path}`, {
      accessTokenFactory: () => getAccessToken() ?? '',
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();
}
